export default "__VITE_ASSET__DEoffyGM__"